import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import ApiService from "../../services/ApiService";
import { SOCIAL_ACCOUNTS } from "../keys";

const useSocialAccounts = () => {
  const tenant = useSelector((state) => state.auth.tenant);

  const query = useQuery({
    queryKey: [SOCIAL_ACCOUNTS, tenant.id],
    queryFn: () => ApiService.getSocialMediaState(),
    select: (response) => {
      const accounts = response?.data || [];
      // Check if tenant has any active social accounts
      const hasActiveSocialAccounts = accounts.some(social => 
        social.accessTokens && social.accessTokens.length > 0 && 
        social.accessTokens.some(token => 
          token.accounts && token.accounts.some(account => account.include === 1)
        )
      );
      return {
        accounts,
        hasActiveSocialAccounts
      };
    },
  });

  return {
    ...query.data,
    hasActiveSocialAccounts: query.data?.hasActiveSocialAccounts || false,
    accounts: query.data?.accounts || [],
    isLoading: query.isLoading,
    isError: query.isError,
  };
};

export default useSocialAccounts;